import React from 'react'
import { Box, Button, Card, CardContent, Chip, Grid, Typography } from '@mui/material';
import { GAME_TYPE_ARRAY, matchedGameTypeLabel } from './GameConstant';

const GameItemCard = ({ index, item, gameData, onItemClick }) => {
    return (
        <Card
            key={item?._id}
            sx={{
                p: 2,
                borderRadius: 2,
                overflow: "hidden",
                // backgroundImage: `url(${item?.banner})`,
                // backgroundSize: 'contain',
                // backgroundRepeat: 'no-repeat',
                // backgroundPosition: "center",
            }}>

            <Box
                sx={{
                    width: "100%",
                    height: "40%",
                    //aspectRatio: "8 / 1",
                    borderRadius: 2,
                    overflow: "hidden",
                    cursor: "pointer",
                    backgroundImage: `${item?.banner}`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    outline: "1px solid grey"
                }}
                onClick={() => onItemClick(index, item, gameData)}
            >
                {/* Top Row */}
                <Grid container justifyContent="space-between" width={"100%"} sx={{ width: '100%' }}>
                    <Typography variant="h6" fontSize={14} fontWeight={600}>{index + 1}{'>'} ID: {item?._id}</Typography>
                    <Typography variant="h6" fontSize={14} fontWeight={600}>{item?.title}</Typography>
                    <Typography variant="subtitle2" fontSize={14} fontWeight={800}>{item?.status}</Typography>
                </Grid>

                {/* Middle Row */}
                <Grid container justifyContent="space-between" width={"100%"} sx={{ width: '100%' }}>
                    <Typography variant="h6" fontSize={14} fontWeight={500} mt={2}>
                        Game Type :{' '}
                        <Box component="span" fontWeight={600}>
                            {matchedGameTypeLabel(item?.type)}
                        </Box>
                    </Typography>

                    <Box sx={{ justifyItems: 'flex-end', alignItems: 'flex-end', width: '100%', mt: -2 }}>
                        <Typography variant="h6" fontSize={14} fontWeight={500}>
                            Go Live At :{' '}
                            <Box component="span" fontWeight={600}>
                                {new Date(item?.rules?.goLiveAt).toLocaleString('en-IN', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true,
                                })}
                            </Box>
                        </Typography>

                        <Typography variant="h6" fontSize={14} fontWeight={500}>
                            Submission At :{' '}
                            <Box component="span" fontWeight={600}>
                                {new Date(item?.rules?.submissionCutOffAt).toLocaleString('en-IN', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true,
                                })}
                            </Box>
                        </Typography>

                        <Typography variant="h6" fontSize={14} fontWeight={500}>
                            Alter Cutoff At :{' '}
                            <Box component="span" fontWeight={600}>
                                {new Date(item?.rules?.alterCutOffAt).toLocaleString('en-IN', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true,
                                })}
                            </Box>
                        </Typography>

                        <Typography variant="h6" fontSize={14} fontWeight={500}>
                            Result Declare At :{' '}
                            <Box component="span" fontWeight={600}>
                                {new Date(item?.rules?.resultDeclarationAt).toLocaleString('en-IN', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true,
                                })}
                            </Box>
                        </Typography>
                    </Box>
                </Grid>

                {/* Bottom Row */}
                {/* <Grid container justifyContent="space-between" mt={1}>
                    <Typography variant="h6" fontSize={14} fontWeight={500}>
                        Game Type :{' '}
                        <Box component="span" fontWeight={600}>
                            {matchedGameTypeLabel(item?.type)}
                        </Box>
                    </Typography>
                </Grid> */}
            </Box>

        </Card>
    )
}

export default GameItemCard;